import TopBackButton from '@/component/common/top-back-button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import SFMenu from '@/component/my/sf-menu';
import TermsAllList from '@/component/terms/TermsAllList';
import { useParams } from 'react-router-dom';
import TermsPrivous from '@/component/terms/TermsPrivous';
import { useTranslation } from 'react-i18next';
import { termsTypeProps } from '@/api/server/terms/read';

export default function TermsPage() {
  const { t } = useTranslation();
  const { path } = useParams();
  const paths = path as termsTypeProps;
  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '812px',
        height: '100vh',
        position: 'relative',
      }}
    >
      <TopBackButton
        title={t('title.termsConditions')}
        backPath="/my"
        boxProps={{
          mb: 4,
        }}
      />
      <SFMenu.Menu>
        <Divider sx={{ mb: 2 }} />
        {path ? <TermsPrivous type={paths} /> : <TermsAllList />}
      </SFMenu.Menu>
    </Container>
  );
}
